import { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import TextViewer from '../../../../component/editor/TextViewer';
import BreadCrumb from '../../../../component/BreadCrumb';
import { useParams, useNavigate } from 'react-router-dom';
import InputBox from '../../../../component/InputBox';
import BoardPupupCheck from '../../../../component/BoardPupupCheck';
import DatePickerBox from '../../../../component/DatePickerBox';
import CommunityDeleteButtonBox from '../../../../component/buttons/CommunityDeleteButtonBox';
import CommunityEditButtonBox from '../../../../component/buttons/CommunityEditButtonBox';
import ConfirmButtonBox from '../../../../component/buttons/ConfirmButtonBox';
import {
    COMMUNITY_NOTICE_EDIT_PATH,
    COMMUNITY_NOTICE_PATH,
    FILE_TYPE,
    PATH_DELIMITER,
    ROLE,
} from '../../../../constant/Constant';
import PopupRef from '../../../../component/PopupRef';
import SingleFileAttachBox from '../../../../component/SingleFileAttachBox';
import MultiFileAttachBox from '../../../../component/MultiFileAttachBox';
import CommunityPostEditorInfoBox from '../../../../component/CommunityPostEditorInfoBox';
import { actionRemove, actionDetail } from '../../../../module/body/community/notice/CommunityNoticeModule';
import { VIEW_COMMUNITY_NOTICE_DETAIL } from '../../../../constant/ViewConstant';
import CodeUtil from '../../../../util/CodeUtil';
import NullCheckUtil from '../../../../util/NullCheckUtil';
import AuthenticationUtil from '../../../../util/AuthenticationUtil';
import { CODE_GROUP_ID } from '../../../../constant/Constant';

const CommunityNoticeDetailView = () => {
    let params = useParams();

    // condition
    const [postingNo, setPostingNo] = useState(params && params.postingNo);
    const [postingTitleNm, setPostingTitleNm] = useState('');
    const [postingCtnt, setPostingCtnt] = useState('');
    const [universityNm, setUniversityNm] = useState('');
    const [noticeTypeCd, setNoticeTypeCd] = useState('');
    const [userNm, setUserNm] = useState('');
    const [regDttm, setRegDttm] = useState('');
    const [noticeBgnDt, setNoticeBgnDt] = useState('');
    const [noticeEndDt, setNoticeEndDt] = useState('');
    const [noticeFileNm, setNoticeFileNm] = useState('');
    const [noticeFileUid, setNoticeFileUid] = useState('');
    const [files, setFiles] = useState([]);
    const [editPermission, setEditPermission] = useState(false);
    const [deletePermission, setDeletePermission] = useState(false);

    const navigate = useNavigate();
    const popupRef = useRef(null);
    const dispatch = useDispatch();

    // 최초 초기화 호출˝
    useEffect(() => {
        window.scrollTo(0, 0);
        initSearch(params.postingNo);
    }, []);

    const initSearch = (postingNo) => {
        dispatch(
            actionDetail({
                params: { postingNo },
                callback: (result) => {
                    setDetail(result);
                },
            }),
        );
    };

    const setDetail = (result) => {
        setPostingTitleNm(result.postingTitleNm);
        setNoticeTypeCd(result.noticeTypeCd);
        setUserNm(result.userNm);
        setRegDttm(result.regDttm);
        setPostingCtnt(result.postingCtnt);
        setNoticeFileNm(result.noticeFileNm);
        setNoticeFileUid(result.noticeFileUid);
        if (NullCheckUtil.isNotEmpty(result.userUniversityCd)) {
            setUniversityNm(
                CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY).find((el) => el.cd == result.userUniversityCd).cdNm,
            );
        }
        if (NullCheckUtil.isNotEmpty(result.noticeBgnDt)) {
            let beginDt = result.noticeBgnDt;
            beginDt = beginDt.substring(0, 4) + '-' + beginDt.substring(4, 6) + '-' + beginDt.substring(6, 8);
            setNoticeBgnDt(beginDt);
        }
        if (NullCheckUtil.isNotEmpty(result.noticeEndDt)) {
            let endDt = result.noticeEndDt;
            endDt = endDt.substring(0, 4) + '-' + endDt.substring(4, 6) + '-' + endDt.substring(6, 8);
            setNoticeEndDt(endDt);
        }
        if (
            AuthenticationUtil.getUserRoleCd() == ROLE.ADMIN ||
            (AuthenticationUtil.getUserRoleCd() == ROLE.STAFF && AuthenticationUtil.getUserId() == result.regUserId)
        ) {
            setEditPermission(true);
            setDeletePermission(true);
        }

        let fileArr = [];
        result.files.forEach((file) => {
            fileArr.push({
                postingNo: file.postingNo,
                fileUid: file.fileUid,
                fileNm: file.fileNm,
                regDttm: file.regDttm,
                noticeTypeCd: file.noticeTypeCd,
            });
        });
        setFiles(fileArr);
    };

    const handleDelete = () => {
        popupRef.current.openWarning('공지사항 ' + postingNo + '(를)을 삭제하시겠습니까?', () => {
            return function () {
                dispatch(
                    actionRemove({
                        params: { postingNo },
                        callback: (pno) => {
                            popupRef.current.openInfo(
                                '게시물 번호 ' + pno + '(가)이 삭제되었습니다. 공지사항 목록으로 이동합니다.',
                                () => {
                                    return function () {
                                        navigate(COMMUNITY_NOTICE_PATH);
                                    };
                                },
                            );
                        },
                    }),
                );
            };
        });
    };

    const handleEdit = () => {
        var path = COMMUNITY_NOTICE_EDIT_PATH + PATH_DELIMITER + postingNo;
        navigate(path);
    };

    const handleConfirm = () => {
        navigate(COMMUNITY_NOTICE_PATH);
    };

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg04'>
                    {/* <h2 className='con-title'>공지사항 내용</h2> */}
                    <h2 className='con-title'>{VIEW_COMMUNITY_NOTICE_DETAIL.title}</h2>
                    <p className='con-title-p'>{VIEW_COMMUNITY_NOTICE_DETAIL.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <div className='community-wrap'>
                    <div className='cmnty-top-box'>
                        <div className='top-box-row full'>
                            <InputBox
                                title='제목'
                                disabled={true}
                                value={postingTitleNm}
                                onChange={(e) => setPostingTitleNm(e.target.value)}
                            />
                        </div>
                        {noticeTypeCd == 'POP-UP' && (
                            <div className='top-box-row divide'>
                                <BoardPupupCheck
                                    title='팝업으로 게시'
                                    disabled={true}
                                    checked={noticeTypeCd == 'POP-UP'}
                                    onChecked={(e) => {
                                        e.target.checked ? setNoticeTypeCd('POP-UP') : setNoticeTypeCd('NORMAL');
                                    }}
                                />
                                <DatePickerBox
                                    title='팝업 시작일자'
                                    value={noticeBgnDt}
                                    size='large'
                                    disabled={true}
                                    onChange={(e) => setNoticeBgnDt(e.target.value)}
                                />
                                <DatePickerBox
                                    title='팝업 종료일자'
                                    value={noticeEndDt}
                                    size='large'
                                    disabled={true}
                                    onChange={(e) => setNoticeEndDt(e.target.value)}
                                />
                                <div className='w-634'>
                                    <SingleFileAttachBox
                                        labelName={'팝업이미지'}
                                        onChangeFile={(e) => {}}
                                        fileUid={noticeFileUid}
                                        fileNm={noticeFileNm}
                                        editable={false}
                                        download={true}
                                        availableTypes={[FILE_TYPE.PNG, FILE_TYPE.JPG, FILE_TYPE.JPEG, FILE_TYPE.GIF]}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    <TextViewer className='cmnty-textarea-box' value={postingCtnt} />
                    <MultiFileAttachBox
                        className='cmnty-file-box'
                        uploadFileHandler={(e) => {}}
                        files={files}
                        editable={false}
                        erasable={false}
                        fileDeleteHandler={(e) => {}}
                    />
                    <CommunityPostEditorInfoBox userNm={userNm} universityNm={universityNm} regDttm={regDttm} />
                    <div className='cmnty-btn-box btn-wrap'>
                        {deletePermission && <CommunityDeleteButtonBox title='삭제' onClick={(e) => handleDelete()} />}
                        {editPermission && <CommunityEditButtonBox title='편집' onClick={(e) => handleEdit()} />}
                        <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default CommunityNoticeDetailView;
